export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_640000-c427a5a4bb99e9bad71fa50539e3f1e6.avif";